module.exports = __webpack_public_path__ + "static/img/卡片初始背景_image@2x.ff4d0458.png";